<template>
  <InteractiveForm
    ref="rfPersonaInfoForm"
    :steps="cptdFormSteps"
    :busy="busy"
    current-form="persona-info"
    :auto-selectable-steps="autoSelectableSteps"
    @submit="submit"
  >
    <template #default="{ step, validation }">
      <MaritalStatusRadioList
        v-if="displayInput(step, 'marital_status')"
        key="maritalOptions"
        v-model="personaInfo.marital_status"
        :validation="validation"
        @input="autoSelectField('marital_status', $event)"
      />
      <!-- GENERO -->
      <GenderCheckInput
        v-if="displayInput(step, 'gender')"
        id="gender"
        key="gender"
        v-model="personaInfo.gender"
        name="gender"
        label="Qual seu gênero?"
        :validation="validation"
        @input="autoSelectField('gender', $event)"
      />
      <!-- ESCOLARIDADE -->
      <EducationalLevelRadioList
        v-if="displayInput(step, 'educational_level')"
        key="educational_level"
        v-model="personaInfo.educational_level"
        title="Selecione escolaridade"
        :validation="validation"
        @input="autoSelectField('educational_level', $event)"
      />
      <!-- NUMERO DO DOCUMENTO -->
      <RGInput
        v-if="displayInput(step, 'rg_number')"
        key="rg_number"
        v-model="personaInfo.rg_number"
        label="Qual é o seu RG?"
        :validation="validation"
      />
      <!-- ESTADO DE EMISSAO -->
      <StateRadioList
        v-if="displayInput(step, 'rg_issuer_state')"
        id="rg_issuer_state"
        key="rg_issuer_state"
        v-model="personaInfo.rg_issuer_state"
        title="Seu RG foi emitido em qual estado?"
        search-placeholder="Buscar estado"
        :searchable="true"
        :validation="validation"
        :validations="{ required: true }"
        @input="autoSelectField('rg_issuer_state', $event)"
      />
      <!-- NOME DA SUA MÃE -->
      <FullNameInput
        v-if="displayInput(step, 'mothers_name')"
        id="mothers_name"
        key="mothers_name"
        v-model="personaInfo.mothers_name"
        name="mothers_name"
        label="Qual o nome completo da sua mãe?"
        helper-message="Digite igual está em seus documentos. Caso não tenha o nome declarado, digite “Nome Ausente”."
        :validation="validation"
      />
      <!-- ESTADO -->
      <StateRadioList
        v-if="displayInput(step, 'birth_state')"
        id="birth_state"
        key="birth_state"
        v-model="personaInfo.birth_state"
        title="Selecione o estado que você nasceu"
        search-placeholder="Buscar estado"
        :searchable="true"
        :validation="validation"
        :validations="{ required: true }"
        @input="autoSelectField('birth_state', $event)"
      />
      <!-- CIDADE -->
      <CitiesRadioList
        v-if="displayInput(step, 'birth_city')"
        id="cityOptions"
        key="cityOptions"
        v-model="personaInfo.birth_city"
        title="Escolha a cidade que você nasceu"
        search-placeholder="Buscar cidade"
        :state="personaInfo.birth_state"
        :searchable="true"
        :validation="validation"
        :validations="{ required: true }"
        @input="autoSelectField('birth_city', $event)"
      />
      <!-- NASCIMENTO -->
      <BirthDateInput
        v-if="displayInput(step, 'birth_date')"
        key="birth_date"
        v-model="personaInfo.birth_date"
        label="Qual a data do seu nascimento?"
        :validation="validation"
      />
    </template>
  </InteractiveForm>
</template>
<script>
import { nextTick } from 'vue'
import InteractiveForm from '@/components/forms/InteractiveForm.vue'
import formatDate from '@/helpers/formatDate'

import { EducationOptions, MaritalOptions } from '@/helpers/persona'
import CitiesRadioList from '@/components/forms/fields/radioInputList/CitiesRadioList.vue'
import StateRadioList from '@/components/forms/fields/radioInputList/StateRadioList.vue'
import EducationalLevelRadioList from '@/components/forms/fields/radioInputList/EducationalLevelRadioList.vue'
import MaritalStatusRadioList from '@/components/forms/fields/radioInputList/MaritalStatusRadioList.vue'
import RGInput from '@/components/forms/fields/input/RGInput.vue'
import BirthDateInput from '@/components/forms/fields/input/BirthDateInput.vue'
import FullNameInput from '@/components/forms/fields/input/FullNameInput.vue'
import GenderCheckInput from '@/components/forms/fields/checkInput/GenderCheckInput.vue'
export default {
  name: 'PersonaInfoInteractiveForm',
  components: {
    CitiesRadioList,
    StateRadioList,
    EducationalLevelRadioList,
    MaritalStatusRadioList,
    RGInput,
    BirthDateInput,
    FullNameInput,
    GenderCheckInput,
    InteractiveForm,
  },
  props: {
    busy: { type: Boolean, default: false },
    displaySteps: { type: Array, default: () => [] },
  },
  emits: ['submit'],
  data() {
    return {
      personaInfo: {
        gender: '',
        name: '',
        educational_level: '',
        birth_city: '',
        birth_date: '',
        birth_state: '',
        marital_status: '',
        mothers_name: '',
        rg_number: '',
        rg_issuer_state: '',
        politically_exposed: false,
      },
      autoSelectableSteps: [
        'gender',
        'educational_level',
        'rg_issuer_state',
        'marital_status',
        'birth_state',
        'birth_city',
      ],
      steps: [
        'gender',
        'marital_status',
        'educational_level',
        'birth_date',
        'birth_state',
        'birth_city',
        'rg_number',
        'rg_issuer_state',
        'mothers_name',
      ],
    }
  },
  computed: {
    cptdFormSteps() {
      if (this.displaySteps?.length > 0) {
        return this.displaySteps
      }

      return this.steps
    },
    maritalOptions() {
      return MaritalOptions.map((ed) => ({
        label: ed.name,
        value: ed.value,
        id: ed.value,
      }))
    },
    educationOptions() {
      return EducationOptions.map((ed) => ({
        label: ed.name,
        value: ed.value,
        id: ed.value,
      }))
    },
  },
  methods: {
    displayInput(step, key) {
      return step === key
    },
    autoSelectField(key, value) {
      this.personaInfo[key] = value
      nextTick(() => {
        this.$refs.rfPersonaInfoForm.next()
      })
    },
    selectField(key, value) {
      this.personaInfo[key] = value
    },
    submit() {
      this.$emit('submit', {
        gender: this.personaInfo.gender,
        name: this.personaInfo.name,
        educational_level: this.personaInfo.educational_level,
        birth_city: this.personaInfo.birth_city,
        birth_date: formatDate(this.personaInfo.birth_date),
        birth_state: this.personaInfo.birth_state,
        marital_status: this.personaInfo.marital_status,
        mothers_name: this.personaInfo.mothers_name,
        rg: {
          number: this.personaInfo.rg_number,
          issuer_state: this.personaInfo.rg_issuer_state,
        },
        politically_exposed: false,
      })
    },
  },
}
</script>
<style lang="scss"></style>
